import { createStore } from 'redux';

import ReceivablesTableState, { getInitialState } from './ReceivablesTable.state';

enum StoreActionType {
  SetPendingReceivablesState,
  SetCompletedReceivablesState,
  AddReceivableSuccess,
  Reset,
}

interface SetPendingReceivablesStateAction {
  readonly type: StoreActionType.SetPendingReceivablesState;
  readonly payload: ReceivablesTableState;
}

interface SetCompletedReceivablesStateAction {
  readonly type: StoreActionType.SetCompletedReceivablesState;
  readonly payload: ReceivablesTableState;
}

interface AddReceivableSuccessAction {
  readonly type: StoreActionType.AddReceivableSuccess;
}

interface ResetPendingReceivablesStateAction {
  readonly type: StoreActionType.Reset;
}

type StoreAction =
  | SetPendingReceivablesStateAction
  | SetCompletedReceivablesStateAction
  | AddReceivableSuccessAction
  | ResetPendingReceivablesStateAction;

interface State {
  pendingReceivablesState: ReceivablesTableState;
  completedReceivablesState: ReceivablesTableState;
}

const initialState: State = {
  pendingReceivablesState: getInitialState({ receivablesType: 'pending' }),
  completedReceivablesState: getInitialState({ receivablesType: 'completed' }),
};

const reducer = (state: State, action: StoreAction): State => {
  switch (action.type) {
    case StoreActionType.SetPendingReceivablesState:
      return {
        ...state,
        pendingReceivablesState: action.payload,
      };
    case StoreActionType.SetCompletedReceivablesState:
      return {
        ...state,
        completedReceivablesState: action.payload,
      };
    case StoreActionType.AddReceivableSuccess:
      return {
        ...state,
        pendingReceivablesState: {
          ...state.pendingReceivablesState,
          grandTotalNumberOfRecords: state.pendingReceivablesState.grandTotalNumberOfRecords + 1,
        },
      };
    case StoreActionType.Reset:
      return { ...initialState };
    default:
      return state;
  }
};

/**
 * Redux store. Allows to store React state outside of component
 * to preserve component state between navigations to other pages
 */
const store = createStore(reducer, initialState);

const selectPendingReceivablesState = (state: State) => state.pendingReceivablesState;
const selectCompletedReceivablesState = (state: State) => state.completedReceivablesState;

export { StoreActionType, selectCompletedReceivablesState, selectPendingReceivablesState };
export default store;
